var map = {
	"./assets/download/shebei.png": "4b8a",
	"./assets/index/shebei.png": "ed03",
	"./assets/solution/ITservice/shebei.png": "452d",
	"./assets/solution/intelFurniture/shebei.png": "fa3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c839";